var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9 12C20.9 16.8601 16.9601 20.8 12.1 20.8C7.2399 20.8 3.30001 16.8601 3.30001 12C3.30001 7.13989 7.2399 3.2 12.1 3.2C16.9601 3.2 20.9 7.13989 20.9 12ZM22.1 12C22.1 17.5228 17.6229 22 12.1 22C6.57716 22 2.10001 17.5228 2.10001 12C2.10001 6.47715 6.57716 2 12.1 2C17.6229 2 22.1 6.47715 22.1 12ZM9.68594 10.6035V9.66016H12.9262V15.0625H14.9945V16H9.68594V15.0625H11.8422V10.6035H9.68594ZM11.8598 8.43555C11.7543 8.31836 11.7016 8.17188 11.7016 7.99609C11.7016 7.90234 11.7152 7.81445 11.7426 7.73242C11.7738 7.65039 11.8207 7.58008 11.8832 7.52148C11.934 7.4707 11.9984 7.43164 12.0766 7.4043C12.1586 7.37305 12.2504 7.35742 12.352 7.35742C12.4535 7.35742 12.5434 7.37305 12.6215 7.4043C12.6996 7.43164 12.7641 7.4707 12.8148 7.52148C12.8773 7.57617 12.9242 7.64453 12.9555 7.72656C12.9867 7.80859 13.0023 7.89844 13.0023 7.99609C13.0023 8.17188 12.9477 8.31836 12.8383 8.43555C12.7289 8.55273 12.5668 8.61133 12.352 8.61133C12.1332 8.61133 11.9691 8.55273 11.8598 8.43555Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOutline);
export default __webpack_public_path__ + "static/media/InfoOutline.bd7f025dddb76eb13d035528b858690b.svg";
export { ForwardRef as ReactComponent };